import { WithFetchDatasByIdFromCMS } from 'modules/shared-cms/hocs';

import { QUERY } from './tendance-query';
import { TendanceLoader } from './tendance-component-loader';
import { TendanceProps } from '.';

const enhancer = WithFetchDatasByIdFromCMS<TendanceProps>(QUERY, TendanceLoader, 'findTendanceContent');
export default enhancer;
